import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const AmazonProductListing = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12704"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12704)">
          <rect
            x="-4"
            y="-3"
            width="123"
            height="115"
            rx="5.2028"
            fill="#ECFEFF"
          />
          <rect
            x="24.3707"
            y="37.3258"
            width="60.4284"
            height="36.1292"
            rx="2.80903"
            fill="white"
            stroke="#191919"
            strokeWidth="0.959181"
          />
          <path
            d="M80.9223 37.4857L25.1699 71.5047C25.1699 71.5047 25.5615 72.4349 26.2586 72.7707C26.9556 73.1065 27.901 73.2951 28.8867 73.2951H80.9223C81.9081 73.2951 82.8535 73.1065 83.5505 72.7707C84.2476 72.4349 84.6391 71.9795 84.6391 71.5047V39.2762C84.6391 38.8013 84.2476 38.3459 83.5505 38.0101C82.8535 37.6744 80.9223 37.4857 80.9223 37.4857Z"
            fill="#E3E3E3"
          />
          <path
            d="M39.0295 45.796H60.771"
            stroke="#191919"
            strokeWidth="1.23323"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M39.0295 50.729H67.1655"
            stroke="#191919"
            strokeWidth="1.23323"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M39.0295 55.6621H60.771"
            stroke="#191919"
            strokeWidth="1.23323"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M39.0295 60.5948H67.1655"
            stroke="#191919"
            strokeWidth="1.23323"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M39.0295 65.5277H67.1655"
            stroke="#191919"
            strokeWidth="1.23323"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="24.3707"
            y="37.3258"
            width="60.4284"
            height="36.1292"
            rx="2.80903"
            stroke="#191919"
            strokeWidth="0.959181"
          />
          <path
            d="M10.2044 46.1914L11.7425 47.7295L16.8696 42.6024L15.3315 41.0643C14.6479 40.4025 13.7316 40.036 12.7802 40.0437C11.8287 40.0514 10.9185 40.4328 10.2457 41.1056C9.57294 41.7783 9.19156 42.6886 9.18384 43.64C9.17611 44.5914 9.54266 45.5078 10.2044 46.1914Z"
            fill="#FF808C"
          />
          <path
            d="M22.4683 58.4552L29.6462 60.506L27.5954 53.3281L22.4683 58.4552Z"
            fill="#FFBC44"
          />
          <path
            d="M16.8696 42.6046L27.5955 53.3305L22.4684 58.4576L11.7425 47.7317L16.8696 42.6046Z"
            fill="#FFEF5E"
          />
          <path
            d="M10.2044 46.1914L11.7425 47.7295L16.8696 42.6024L15.3315 41.0643C14.6479 40.4025 13.7316 40.036 12.7802 40.0437C11.8287 40.0514 10.9185 40.4328 10.2457 41.1056C9.57294 41.7783 9.19156 42.6886 9.18384 43.64C9.17611 44.5914 9.54266 45.5078 10.2044 46.1914Z"
            stroke="#191919"
            strokeWidth="0.959181"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.4683 58.4552L29.6462 60.506L27.5954 53.3281L22.4683 58.4552Z"
            stroke="#191919"
            strokeWidth="0.959181"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.8696 42.6046L27.5955 53.3305L22.4684 58.4576L11.7425 47.7317L16.8696 42.6046Z"
            stroke="#191919"
            strokeWidth="0.959181"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="71.6903"
            y="25.1762"
            width="33.5713"
            height="33.5713"
            rx="16.7857"
            fill="white"
          />
          <rect
            x="71.6903"
            y="25.1762"
            width="33.5713"
            height="33.5713"
            rx="16.7857"
            stroke="#1E1E1E"
            strokeWidth="0.959181"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M89.2796 40.3292C89.2796 41.1186 89.2982 41.7748 88.9009 42.4764C88.5793 43.0473 88.0673 43.3978 87.5002 43.3978C86.7223 43.3978 86.2687 42.8057 86.2687 41.9292C86.2687 40.2043 87.8161 39.8903 89.2802 39.8903L89.2796 40.3292ZM91.321 45.2662C91.1871 45.3873 90.993 45.395 90.8437 45.3137C90.1696 44.7549 90.0504 44.4961 89.6814 43.9642C88.5703 45.0964 87.7834 45.436 86.3437 45.436C84.6393 45.436 83.3123 44.3846 83.3123 42.2803C83.3123 40.6368 84.2035 39.5193 85.4716 38.9715C86.5705 38.4883 88.1051 38.4006 89.279 38.2698V38.0071C89.279 37.5246 89.3174 36.955 89.0336 36.5372C88.7869 36.1662 88.3133 36.0118 87.8962 36.0118C87.1241 36.0118 86.4372 36.4078 86.2687 37.2273C86.2341 37.4099 86.1015 37.5906 85.9169 37.6003L83.9556 37.3869C83.7896 37.351 83.6044 37.2164 83.6531 36.964C84.1042 34.5829 86.2546 33.864 88.1807 33.864C89.1655 33.864 90.4535 34.1267 91.2294 34.8726C92.2149 35.7927 92.1213 37.0204 92.1213 38.357V41.5114C92.1213 42.4604 92.5161 42.8762 92.8851 43.3882C93.0158 43.5721 93.0434 43.7919 92.8787 43.9258C92.4642 44.2724 91.7292 44.9106 91.3262 45.2707L91.321 45.2662Z"
            fill="#1E1E1E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M93.6025 46.9795C91.8417 47.9227 89.9277 48.377 88.1862 48.377C85.6058 48.377 83.1069 47.4844 81.086 46.0023C80.9085 45.8729 80.7778 46.101 80.9251 46.2689C82.7993 48.4 85.2733 49.6815 88.0221 49.6815C89.9835 49.6815 92.2601 48.9037 93.8312 47.4428C94.0914 47.2012 93.8684 46.8372 93.6025 46.9795ZM94.0318 48.3994C93.9735 48.5448 94.0984 48.6044 94.2304 48.4936C95.0884 47.7759 95.3101 46.2727 95.1345 46.0562C94.9602 45.8409 93.4609 45.655 92.5459 46.2977C92.4049 46.3964 92.4292 46.5329 92.5856 46.5137C93.1014 46.4521 94.2483 46.3137 94.4521 46.5765C94.6565 46.8392 94.2246 47.9182 94.0318 48.3994Z"
            fill="#FF9900"
          />
          <g clipPath="url(#clip0_1529_12704)">
            <path
              d="M86.8521 76.0024H73.0645C72.7592 76.0024 72.4618 75.9049 72.2158 75.724C71.9697 75.5431 71.788 75.2883 71.697 74.9968L70.2052 70.2217C70.1383 70.0073 70.1227 69.7802 70.1597 69.5586C70.1968 69.3371 70.2854 69.1274 70.4184 68.9464C70.5514 68.7654 70.7251 68.6183 70.9255 68.5168C71.1258 68.4153 71.3473 68.3624 71.5719 68.3623H87.9198C88.1266 68.363 88.3279 68.2959 88.4929 68.1713L87.6161 76.371C87.5291 76.2513 87.4138 76.155 87.2805 76.0907C87.1472 76.0264 87 75.996 86.8521 76.0024Z"
              fill="#C2F3FF"
            />
            <path
              d="M74.8714 73.2461C74.5663 73.246 74.2693 73.1485 74.0234 72.9678C73.7776 72.7871 73.5959 72.5326 73.5048 72.2415L72.2919 68.3622H71.5719C71.3473 68.3623 71.1258 68.4152 70.9255 68.5167C70.7251 68.6182 70.5514 68.7654 70.4184 68.9463C70.2854 69.1273 70.1968 69.337 70.1597 69.5586C70.1227 69.7801 70.1383 70.0072 70.2052 70.2216L71.697 74.9967C71.788 75.2882 71.9697 75.543 72.2158 75.7239C72.4618 75.9048 72.7592 76.0024 73.0645 76.0023H86.8521C87 75.996 87.1471 76.0264 87.2804 76.0907C87.4137 76.155 87.5291 76.2513 87.6162 76.371L87.9495 73.2461H74.8714Z"
              fill="#66E1FF"
            />
            <path
              d="M92.1047 64.5418H89.6618C89.5446 64.5409 89.4312 64.5831 89.3432 64.6604C89.2551 64.7377 89.1986 64.8447 89.1843 64.961L88.8672 67.5243C88.8386 67.7554 88.7265 67.9681 88.552 68.1223C88.3775 68.2766 88.1527 68.3617 87.9198 68.3618H71.5719C71.3473 68.362 71.1258 68.4149 70.9255 68.5164C70.7251 68.6178 70.5514 68.765 70.4184 68.946C70.2854 69.127 70.1968 69.3367 70.1597 69.5582C70.1227 69.7797 70.1383 70.0069 70.2052 70.2213L71.697 74.9963C71.788 75.2878 71.9697 75.5426 72.2158 75.7235C72.4618 75.9045 72.7592 76.002 73.0645 76.002H86.8521C87.1054 76.002 87.3483 76.1026 87.5274 76.2817C87.7065 76.4608 87.8072 76.7037 87.8072 76.957C87.8072 77.2103 87.7065 77.4532 87.5274 77.6323C87.3483 77.8114 87.1054 77.912 86.8521 77.912H73.4819"
              stroke="#191919"
              strokeWidth="0.959181"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M88.2856 70.272L87.8635 74.071"
              stroke="#191919"
              strokeWidth="0.959181"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M75.393 82.6876C75.7729 82.6876 76.1373 82.5366 76.4059 82.268C76.6746 81.9993 76.8255 81.635 76.8255 81.255C76.8255 80.8751 76.6746 80.5107 76.4059 80.2421C76.1373 79.9734 75.7729 79.8225 75.393 79.8225C75.013 79.8225 74.6487 79.9734 74.38 80.2421C74.1114 80.5107 73.9604 80.8751 73.9604 81.255C73.9604 81.635 74.1114 81.9993 74.38 82.268C74.6487 82.5366 75.013 82.6876 75.393 82.6876Z"
              fill="#D7D7D7"
              stroke="#191919"
              strokeWidth="0.959181"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M85.8981 82.6876C86.278 82.6876 86.6424 82.5366 86.9111 82.268C87.1797 81.9993 87.3306 81.635 87.3306 81.255C87.3306 80.8751 87.1797 80.5107 86.9111 80.2421C86.6424 79.9734 86.278 79.8225 85.8981 79.8225C85.5182 79.8225 85.1538 79.9734 84.8852 80.2421C84.6165 80.5107 84.4656 80.8751 84.4656 81.255C84.4656 81.635 84.6165 81.9993 84.8852 82.268C85.1538 82.5366 85.5182 82.6876 85.8981 82.6876Z"
              fill="#D7D7D7"
              stroke="#191919"
              strokeWidth="0.959181"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1529_12704">
            <rect
              width="23.6598"
              height="23.6598"
              fill="white"
              transform="translate(69.2922 61.7844)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
